export default function NumpyUfunc_CreateFunction() {
  return <div>NumpyUfunc_CreateFunction Component</div>;
}
